var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSort = function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    fill: "currentColor",
    viewBox: "0 0 489.389 489.389"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261.294 326.102c-8.3-7.3-21.8-6.2-29.1 2.1l-77 86.8v-346.9c0-11.4-9.4-20.8-20.8-20.8s-20.8 9.4-20.8 20.8v346.9l-77-86.8c-8.3-8.3-20.8-9.4-29.1-2.1-8.3 8.3-9.4 20.8-2.1 29.1l113.4 126.9c8.5 10.5 23.5 8.9 30.2 0l114.4-126.9c7.3-8.2 6.3-21.8-2.1-29.1zM483.994 134.702l-112.4-126.9c-10-10.1-22.5-10.7-31.2 0l-114.4 126.9c-7.3 8.3-6.2 21.8 2.1 29.1 12.8 10.2 25.7 3.2 29.1-2.1l77-86.8v345.9c0 11.4 9.4 20.8 20.8 20.8s20.8-8.3 20.8-19.8v-346.8l77 86.8c8.3 8.3 20.8 9.4 29.1 2.1 8.3-8.4 9.4-20.9 2.1-29.2z"
  })));
};
export default SvgSort;